module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_05.afcd42a3.png";